import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Navigation = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const navItems = [
    { path: '/', label: t('nav_home'), icon: 'ri-home-line' },
    { path: '/introducao', label: t('nav_intro'), icon: 'ri-book-open-line' },
    { path: '/componentes', label: t('nav_components'), icon: 'ri-settings-3-line' },
    { path: '/funcionamento', label: t('nav_operation'), icon: 'ri-play-circle-line' },
    { path: '/problemas', label: t('nav_problems'), icon: 'ri-error-warning-line' },
    { path: '/diagnostico', label: t('nav_diagnosis'), icon: 'ri-search-line' },
    { path: '/engenheiro', label: t('nav_engineer'), icon: 'ri-user-settings-line' },
    { path: '/seguranca', label: t('nav_safety'), icon: 'ri-shield-check-line' },
    { path: '/elektrisch-schakelen', label: t('nav_electrical'), icon: 'ri-flashlight-line' },
    { path: '/quiz1', label: t('nav_quiz1'), icon: 'ri-question-line' },
    { path: '/quiz2', label: t('nav_quiz2'), icon: 'ri-question-line' },
    { path: '/quiz3', label: t('nav_quiz3'), icon: 'ri-question-line' },
  ];

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
  };

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-truck-line text-2xl text-blue-600"></i>
            </div>
            <h1 className="text-xl font-bold text-gray-800">Sistemas Logísticos</h1>
          </div>
          
          <div className="hidden md:flex items-center space-x-1 overflow-x-auto">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname === item.path
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-600 hover:bg-blue-50 hover:text-blue-600'
                }`}
              >
                <div className="flex items-center space-x-1">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={item.icon}></i>
                  </div>
                  <span>{item.label}</span>
                </div>
              </Link>
            ))}
          </div>

          <div className="flex items-center space-x-2">
            <div className="flex items-center space-x-1 bg-gray-100 rounded-lg p-1">
              <button
                onClick={() => changeLanguage('nl')}
                className={`px-2 py-1 rounded text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  i18n.language === 'nl' ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-200'
                }`}
              >
                NL
              </button>
              <button
                onClick={() => changeLanguage('en')}
                className={`px-2 py-1 rounded text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  i18n.language === 'en' ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-200'
                }`}
              >
                EN
              </button>
              <button
                onClick={() => changeLanguage('pt')}
                className={`px-2 py-1 rounded text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  i18n.language === 'pt' ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-200'
                }`}
              >
                PT
              </button>
            </div>

            <div className="md:hidden">
              <select 
                className="bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm cursor-pointer pr-8"
                value={location.pathname}
                onChange={(e) => window.location.href = e.target.value}
              >
                {navItems.map((item) => (
                  <option key={item.path} value={item.path}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
